export type SolveCornerPlacementModelMode =
    (typeof SolveCornerPlacementModelMode)[keyof typeof SolveCornerPlacementModelMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SolveCornerPlacementModelMode = {
    Automatic: 'Automatic',
    Manual: 'Manual'
} as const;
